import { NAV_LINKS } from "@/lib/site-data";

const Footer = () => {
  const year = new Date().getFullYear();
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="relative bg-[#070708] border-t border-white/10 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="h-2 w-2 bg-cyan-400 rounded-full shadow-[0_0_12px_#00F0FF]" />
              <span className="font-display font-700 text-lg tracking-tight text-white">QUANTINIUM</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-zinc-400 max-w-xs">
              Embedded software & full-system design. Real-time firmware, IoT and
              cloud — engineered to last.
            </p>
          </div>

          <div className="md:col-span-4 md:col-start-9">
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
              Navigate
            </span>
            <div className="mt-5 grid grid-cols-2 gap-y-3">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.href}
                  onClick={() => go(l.href)}
                  className="text-left font-mono text-sm text-zinc-400 hover:text-cyan-400 transition-colors duration-300"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="border-t border-white/10 pt-10">
          <div className="font-display font-700 tracking-tighter text-[16vw] leading-none text-stroke select-none">
            QUANTINIUM
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <span className="font-mono text-xs text-zinc-600">
            © {year} Quantinium Limited. Registered in the United Kingdom.
          </span>
          <span className="font-mono text-xs text-zinc-600">
            Engineering the invisible systems inside.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
